import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getContractDetails, getContractList } from "./Services";



export const useGetContracts = () => {

  const query = useQuery(
    [endpoints.getContractList],
    () => {
      return getContractList();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};


export const useGetContractDetails = (contractId:string) => {

  const query = useQuery(
    [endpoints.getContractDetails,contractId],
    () => {
      return getContractDetails(contractId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
}


